<template>
  <div class="contact-tile">
    <div class="contact-tile-content">
      <div
        v-if="contact.firstName || contact.lastName"
        class="name"
      >
        {{ contact.firstName }} {{ contact.lastName }}
      </div>
      <a
        v-if="contact.phoneNumber"
        :href="'tel:' + contact.phoneNumber"
      >
        {{ $methods.formatPhoneNumber(contact.phoneNumber) }}
      </a>
      <a
        v-if="contact.email"
        :href="'mailto:' + contact.email"
      >
        {{ contact.email }}
      </a>
    </div>
    <DotsSvg @click.stop="onDotsClicked" />
    <div
      v-if="showMenu"
      class="menu"
    >
      <div v-click-outside="closeMenu">
        <div
          class="menu-option"
          @click="onEditContactClicked"
        >
          Edit Contact
        </div>
        <div
          class="menu-option"
          @click="onDeleteContactClicked"
        >
          Delete Contact
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Contact } from '@/@types/responses/contact/Contact'
import { defineComponent } from 'vue'
import DotsSvg from '@/components/svgs/DotsSvg.vue'

export default defineComponent({
  name: 'ContactTile',
  components: {
    DotsSvg
  },
  props: {
    contact: {
      type: Contact,
      required: true
    }
  },
  emits: ['delete', 'edit'],
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    closeMenu(): void {
      this.showMenu = false
    },
    onDeleteContactClicked(): void {
      this.closeMenu()
      this.$emit('delete', this.contact)
    },
    onDotsClicked(): void {
      this.showMenu = true
    },
    onEditContactClicked(): void {
      this.closeMenu()
      this.$emit('edit', this.contact)
    }
  }
})
</script>

<style scoped lang="scss">
.contact-tile {
  position: relative;
  background-color: $Color-fill-gray;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  display: flex;

  > .contact-tile-content {
    flex: 0 0 90%;
    display: flex;
    flex-direction: column;
    line-height: 24px;

    > .name {
      color: $Color-font-high;
    }

    > a {
      color: $Color-font-medium;
      text-decoration: none;
      font-style: italic;
      font-size: 15px;
    }
  }

  > svg {
    flex: 0 0 10%;
    margin: auto 10px;
  }

  > .menu {
    @include menu;
  }
}
</style>